import { render, staticRenderFns } from "./HistoryView.vue?vue&type=template&id=6bf12a59&scoped=true&"
import script from "./HistoryView.vue?vue&type=script&lang=js&"
export * from "./HistoryView.vue?vue&type=script&lang=js&"
import style0 from "./HistoryView.vue?vue&type=style&index=0&id=6bf12a59&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf12a59",
  null
  
)

export default component.exports